module.exports = __webpack_public_path__ + "img/daftar-tunggu.65d442ba.svg";